import DynamicImage from "./DynamicImage";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import { HighlightText } from "./HighlightText";

const OurGlobalPresence = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  return (
    <>
      <section
        className={`process-area ptb-70 bg-fafafb ${backgroundClass}`}
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="container">
          <div className="section-title">
            <h2><HighlightText content={data.title} /></h2>
            {data?.description?.map((block, i) => {
              if (block.type === "paragraph") {
                return (
                  <p key={i}>{block.children.map((c) => c.text).join("")}</p>
                );
              }
              return null;
            })}
          </div>

          <div className="row align-items-center gy-4 m-0 gx-lg-5 justify-content-center">
            <div className="col-lg-6 col-md-12 p-0">
              <div className="process-image">
                <DynamicImage image={data.image} />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 p-0">
              <div className="process-content">
                <div className="row">
                    {data?.description?.map((block, i) => {
                      if (block.type === "heading") {
                        return (
                  <div className="col-lg-12 mb-3">
                          <h4 key={i}>
                            <HighlightText content={block.children.map((c) => c.text).join("")} />
                          </h4>
                  </div>
                        );
                      }
                      return null;
                    })}
                  {data?.commitments?.map((item, index) => {
                    return (
                      <div className="col-lg-12 col-md-6" key={index}>
                        <div className="single-box-item">
                          <div className="d-flex align-items-center">
                            <div className="image">
                              <DynamicImage image={item.image} />
                            </div>
                            <h3>{item.title}</h3>
                            <div className="number">{index + 1}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-lg-10">
              {data?.description?.map((block, i) => {
                if (block.type === "quote") {
                  return (
                    <div className="partner-quote">
                      <h6 key={i}>
                        <HighlightText content={block.children.map((c) => c.text).join("")} />
                      </h6>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurGlobalPresence;
